import { ajax } from "@/api/request";

export const getPermission = function(data) {
  return ajax({
    method: 'post',
    url: '/sys/v1/getMenuList',
    data
  });
}
